// TES-1351 / TES-1352 (Emelie 2026-10-14, TES-1350 §1, §2, §5) — what the AI
// draft does to the coach's composer, as pure functions so the rules can be
// tested without a browser.

// "Lägg till i svaret" must "faktiskt lägga frågan sist i den befintliga
// texten, med korrekt radbrytning och utan att ersätta något". Only the
// composer's trailing whitespace is replaced by the one blank line; every
// character the coach wrote stays where it was.
export function appendToComposer(current: string, addition: string): string {
  const add = addition.trim();
  if (!add) return current;
  const head = current.replace(/\s+$/u, "");
  return head ? `${head}\n\n${add}` : add;
}

// "Förkasta utkastet" removes the AI's text, not the coach's. Decision
// (TES-1351): each part the AI put into the composer (the reply, an appended
// follow-up or next step) is removed while it is still there word for word.
// A part the coach has edited has become her text and stays, and so does
// anything she wrote herself: a discard never deletes words she typed.
export function removeDraftParts(
  current: string,
  parts: readonly string[],
): string {
  let out = current;
  for (const part of parts) {
    const p = part.trim();
    if (!p) continue;
    const at = out.indexOf(p);
    if (at === -1) continue;
    out = out.slice(0, at) + out.slice(at + p.length);
  }
  if (out === current) return current;
  return out.replace(/\n{3,}/gu, "\n\n").trim();
}

// Emelie's own example: "Underlag som använts · 2 uppgifter".
export function usedMemorySummary(count: number): string {
  return `Underlag som använts · ${count} ${count === 1 ? "uppgift" : "uppgifter"}`;
}

export function draftDate(iso: string): string {
  return new Date(iso).toLocaleDateString("sv-SE", {
    timeZone: "Europe/Stockholm",
  });
}
